<!-- 月度计划管理 -->
<template>
  <div>
    <!-- <matrix-statistics span="8" :list="infoCardData(cardData)"></matrix-statistics> -->
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange" :beforeOpen="beforeOpen" @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad" @selection-change="selectionChange">
      <template slot="menuLeft">
        <el-button type="primary" icon="el-icon-upload2" plain @click="onImport">导入</el-button>
        <el-button type="primary" icon="el-icon-download" plain size="small" :loading="exportLoading" @click="handleExport">导出</el-button>
        <el-button type="default" icon="el-icon-download" plain size="small" :loading="templateLoading" @click="handleTemplate">导入模板</el-button>
      </template>

      <template slot-scope="{row,index}" slot="menu">
        <el-button
        size="small"
        type="text"
        @click="handleDetail(row)">详情</el-button>
        <el-button
        icon="el-icon-delete"
        size="small"
        type="text"
        @click="joinEve(row,index)">入库</el-button>
        <el-button
        icon="el-icon-delete"
        size="small"
        type="text"
        @click="lossEve(row,index)">损耗</el-button>
      </template>



    </avue-crud>
    <dialog-reset slotShow height="65vh" top="5vh" width="80%" title="新增入库单" :visible.sync="formVisible">
      <materialWarehousing ref="materialWarehousing" @success="warehousingSuccess" @handleClose="handleClose" />

    <span slot="dialog_footer">
      <el-button type="primary"
                 icon="el-icon-circle-plus-outline"
                 @click="submit">提 交</el-button>
    </span>
    </dialog-reset>
    <dialog-reset slotShow height="65vh" top="5vh" width="80%" title="损耗盘点" :visible.sync="LossformVisible">
      <LossInventory ref="LossInventory" @success="LossInventorySuccess"  @handleClose="()=>{}" />
    <span slot="dialog_footer">
      <el-button type="primary"
                 icon="el-icon-circle-plus-outline"
                 @click="lossSubmit">提 交</el-button>
    </span>
    </dialog-reset>
    <dialog-reset title="应急物资入库导入" :visible.sync="excelBox" height="auto" width="650px">
      <avue-form :option="excelOption" v-model="excelForm" :upload-after="uploadAfter">
        <template slot="excelTemplate">
          <el-button type="primary" @click="handleTemplate">
            点击下载<i class="el-icon-download el-icon--right"></i>
          </el-button>
        </template>
      </avue-form>
    </dialog-reset>
    <el-dialog
      title="应急物资详情"
      :visible.sync="detailDialogVisible"
      width="900px"
      append-to-body
      :close-on-click-modal="false"
      @closed="resetDetailDialog"
    >
      <div v-loading="detailLoading" class="material-detail">
        <div class="detail-section-title">物资信息</div>
        <div class="detail-grid">
          <div
            v-for="item in detailFields"
            :key="item.prop"
            class="detail-item"
            :class="{ 'detail-item--wide': item.span === 24 }"
          >
            <span class="detail-label">{{ item.label }}</span>
            <span class="detail-value">{{ formatDetailValue(item) }}</span>
          </div>
        </div>

        <div class="detail-section-title detail-storage-title">储备点数量</div>
        <el-table :data="detailStorageList" border size="small" empty-text="暂无储备点数量数据">
          <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
          <el-table-column prop="storagePointName" label="储备点" min-width="220" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formatStoragePointName(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="currentStock" label="当前数量" min-width="140" align="right">
            <template slot-scope="scope">
              {{ formatEmpty(scope.row.currentStock) }}
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="180" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formatEmpty(scope.row.remark) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="detailDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, getDetail, downloadImportTemplate, exportExcel } from "./api";
import { getSearchTimeConfig, rulesInput } from "@/basic-common/util/common";
import matrixStatistics from '@/components/matrix/matrix-statistics'
import { downloadXls } from '@/util/util'

import materialWarehousing from './components/material-warehousing.vue'
import LossInventory from './components/Loss-inventory.vue'

export default {
  components: { matrixStatistics, materialWarehousing ,LossInventory},
  mixins: [crudMixins],
  data () {
    const that = this
    return {
      formVisible:false,
      LossformVisible:false,
      currentMaterial: {},
      excelBox: false,
      templateLoading: false,
      exportLoading: false,
      detailDialogVisible: false,
      detailLoading: false,
      detailForm: {},
      detailFields: [
        { label: '物资编号', prop: 'materialCode' },
        { label: '物资名称', prop: 'materialName' },
        { label: '物资类型', prop: 'materialType' },
        { label: '数量单位', prop: 'unit' },
        { label: '物资数量', prop: 'materialQuantity' },
        { label: '库存数量阈值', prop: 'stockThreshold' },
        { label: '有效期阈值', prop: 'expiryThreshold' },
        { label: '负责人名称', prop: 'personChargeName' },
        { label: '负责人电话', prop: 'contactPhone' },
        { label: '状态', prop: 'status', dicProp: 'status' },
        { label: '备注', prop: 'remark', span: 24 },
      ],
      form: {},
      excelForm: {},
      apiConfig: { getList, add, update, getDetail },
      excelOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: "文件上传",
            prop: "excelFile",
            type: "upload",
            drag: true,
            loadText: "文件上传中，请稍等",
            showFileList: false,
            propsHttp: {
              res: "data",
            },
            tip: "请上传 .xls,.xlsx 标准格式文件",
            action: "/api/produce/emergency-material/import-excel",
          },
          {
            label: "模板下载",
            prop: "excelTemplate",
            formslot: true,
          },
        ],
      },
      option: {
        ...this.$store.state.publicOption,
        searchDateProp: false,
        selection: false,
        delBtn: false,
        viewBtn: false,
        column: [
          {
            label: '物资编号',
            prop: 'materialCode',
            overHidden: true,
            minWidth: 120,
            search: true,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '物资类型',
            prop: 'materialType',
            search: true,
            overHidden: true,
            width: 120,
            type: 'select',
            dicUrl: '/api/blade-system/dict-biz/dictionary?code=emergency_materialType',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'string',
            rules: rulesInput(2),
          },
          {
            label: '物资名称',
            prop: 'materialName',
            overHidden: true,
            minWidth: 150,
            maxlength: 100,
            search: true,
            rules: rulesInput(1),
          },
          {
            label: '数量单位',
            prop: 'unit',
            search: true,
            overHidden: true,
            width: 100,
            type: 'select',
            dicUrl: '/api/blade-system/dict-biz/dictionary?code=emergency_unit',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'string',
            rules: rulesInput(2),
          },
          {
            label: '物资数量',
            prop: 'materialQuantity',
            type: 'number',
            precision: 0,
            min: 0,
            max: 999999,
            overHidden: true,
            width: 120,
            placeholder: '请输入物资数量',
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '库存数量阈值',
            prop: 'stockThreshold',
            type: 'number',
            precision: 0,
            min: 0,
            max: 999999,
            overHidden: true,
            width: 140,
            placeholder: '低于此数量时预警',
            rules: rulesInput(2),
          },
          {
            label: '有效期阈值',
            prop: 'expiryThreshold',
            type: 'number',
            precision: 0,
            min: 1,
            max: 3650,
            overHidden: true,
            width: 140,
            placeholder: '距离过期天数',
            rules: rulesInput(2),
          },
          {
            label: '负责人名称',
            prop: 'personChargeName',
            overHidden: true,
            width: 120,
            type: 'input',
            maxlength: 50,
            search: true,
            placeholder: '请输入负责人姓名',
            rules: rulesInput(2),
          },
          {
            label: '负责人电话',
            prop: 'contactPhone',
            overHidden: true,
            width: 130,
            type: 'input',
            maxlength: 20,
            search: true,
            placeholder: '请输入联系电话',
            rules: [
              { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
            ],
          },
          {
            label: '状态',
            prop: 'status',
            type: 'select',
            search: true,
            overHidden: true,
            width: 100,
            dicData: [
              { label: '无效', value: 0 },
              { label: '有效', value: 1 },
            ],
            value: 1,
            rules: rulesInput(2),
          },
          {
            label: '备注',
            prop: 'remark',
            type: 'textarea',
            maxlength: 500,
            span: 24,
            minRows: 3,
            hide: true,
          },
          {
            label: '录入人',
            prop: 'createName',
            addDisplay: false,
            editDisplay: false,
            hide: true,
          },
          {
            label: '录入时间',
            prop: 'createTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true,
            width: 180,
            addDisplay: false,
            editDisplay: false,
          },
          {
            ...getSearchTimeConfig('', { type: 'datetimerange' }),
            searchValue: [],
            clearable: true,
            paramsKey: ["startTime", "endTime"],
          },
          {
            label: '修改人',
            prop: 'updateName',
            addDisplay: false,
            editDisplay: false,
            hide: true,
          },
          {
            label: '修改时间',
            prop: 'updateTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true,
            width: 180,
            addDisplay: false,
            editDisplay: false,
            hide: true,
          },
        ]
      },
      defaultParams: {}
    }
  },
  computed: {
    detailStorageList() {
      return (this.detailForm && this.detailForm.extList) || [];
    },
    infoCardData () {
      return function (cardData) {
        return [{
          label: '当月计划入库总量',
          value: cardData['planMonthWeight'],
          unit: ' 吨',
        }, {
          label: '当前执行进度',
          value: cardData['planMonthProgress'],
          unit: ' %',
        }, {
          label: '计划完成率',
          value: cardData['planMonthExecuteWeight'],
          unit: ' 吨',
        }] // 卡片数据
      }
    }
  },
  methods: {
    async handleDetail(row) {
      this.detailDialogVisible = true;
      this.detailLoading = true;
      this.detailForm = {};
      try {
        const res = await getDetail(row.id);
        this.detailForm = res.data.data || res.data || {};
      } catch (e) {
        this.$message.error((e && e.message) || '详情加载失败');
      } finally {
        this.detailLoading = false;
      }
    },
    resetDetailDialog() {
      this.detailForm = {};
      this.detailLoading = false;
    },
    formatDetailValue(item) {
      const value = this.detailForm ? this.detailForm[item.prop] : '';
      if (item.dicProp) {
        return this.formatDicLabel(item.dicProp, value);
      }
      return this.formatEmpty(value);
    },
    formatDicLabel(prop, value) {
      const column = this.option.column.find(item => item.prop === prop);
      const dicData = (column && column.dicData) || [];
      const match = dicData.find(item => String(item.value) === String(value));
      return match ? match.label : this.formatEmpty(value);
    },
    formatEmpty(value) {
      return value === 0 || value ? value : '-';
    },
    formatStoragePointName(row) {
      if (!row) {
        return '-';
      }
      return this.formatEmpty(row.storagePointName || row.pointName || row.storagePointId);
    },
    joinEve(row,index) {
      this.currentMaterial = { ...row }
      this.formVisible = true
      this.$nextTick(() => {
        if (this.$refs.materialWarehousing) {
          this.$refs.materialWarehousing.initMaterial(this.currentMaterial)
        }
      })
    },
    lossEve(row,index){
      this.currentMaterial = { ...row }
      this.LossformVisible = true
      this.$nextTick(() => {
        if (this.$refs.LossInventory) {
          this.$refs.LossInventory.initMaterial(this.currentMaterial)
        }
      })
    },
    lossSubmit(){
      this.$refs.LossInventory.toSubmit()
    },
    submit(){
      this.$refs.materialWarehousing.submit()
    },
    handleClose(){
      this.formVisible = false
    },
    warehousingSuccess(){
      this.formVisible = false
      this.onLoad(this.page);
    },
    LossInventorySuccess(){
      this.LossformVisible = false
      this.onLoad(this.page);
    },
    onImport() {
      this.excelBox = true;
    },
    uploadAfter(res, done) {
      if (!(res instanceof Error)) {
        this.$message.success("入库导入成功");
      }
      this.excelBox = false;
      this.onLoad(this.page, this.query);
      done();
    },
    async handleTemplate() {
      this.templateLoading = true;
      try {
        const res = await downloadImportTemplate();
        downloadXls(res.data, `应急物资入库导入模板_${Date.now()}.xlsx`);
        this.$message.success("模板下载成功");
      } catch (e) {
        this.$message.error((e && e.message) || "模板下载失败");
      } finally {
        this.templateLoading = false;
      }
    },
    async handleExport() {
      this.exportLoading = true;
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query));
        const res = await exportExcel(params);
        downloadXls(res.data, `应急物资_${Date.now()}.xlsx`);
        this.$message.success("导出成功");
      } catch (e) {
        this.$message.error((e && e.message) || "导出失败");
      } finally {
        this.exportLoading = false;
      }
    }

  }
}
</script>
<style scoped lang="scss">
p {
  margin: 0;
}

.material-detail {
  .detail-section-title {
    margin-bottom: 12px;
    padding-left: 8px;
    border-left: 3px solid #409eff;
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    line-height: 1;
  }

  .detail-storage-title {
    margin-top: 20px;
  }

  .detail-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    border-top: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
  }

  .detail-item {
    display: grid;
    grid-template-columns: 130px minmax(0, 1fr);
    min-height: 38px;
    border-right: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
  }

  .detail-item--wide {
    grid-column: 1 / -1;
  }

  .detail-label {
    padding: 10px 12px;
    background: #f5f7fa;
    color: #606266;
    line-height: 18px;
  }

  .detail-value {
    padding: 10px 12px;
    color: #303133;
    line-height: 18px;
    word-break: break-all;
  }
}
</style>
